interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export function Spinner({ size = 'md' }: SpinnerProps) {
  return (
    <div
      className={`${SIZE_MAP[size]} animate-spin rounded-full border-accent-purple border-t-transparent`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default Spinner;
